export const getActiveState = (states) => {
  const activeState = Object.entries(JSON.parse(states)).filter(
    (item) => item[1].active === 1
  );
  if (activeState.length === 0) return null;
  return activeState[0][0];
};

export function hideNumber(
  string,
  replaceTo = '*',
  elemsHide = 4,
  sliceFromback = 4
) {
  if (parseInt(string)) {
    let result = string.match(
      /^(\(?\+?\d{1,2}\)? ?\(?\d{1,3}\)? ?\d+\-? ?\d+\-? ?\d+)$/
    );
    if (result !== null) {
      var hidedNumber = Array.from(string).reduceRight(
        function (ctx, char) {
          var isDigit = char >= '0' && char <= '9';
          var offset = ctx.offset + (isDigit ? 1 : 0);
          var filteredChar = isDigit
            ? offset >= 4 && offset < 8
              ? '*'
              : char
            : char;
          var filtered = filteredChar + ctx.filtered;
          return { offset: offset, filtered: filtered };
        },
        { offset: -1, filtered: '' }
      ).filtered;
      return `${string.startsWith('7') ? '+' : ''}${hidedNumber}`;
    } else {
      return string;
    }
  }
  return string;
}

export const clearTextFromTags = (text) => {
  let rex = /(<([^>]+)>)/gi; //
  let content = text.replace(rex, ' '); //
  //  Отрезаю html тэги и спец символы html
  rex = /&(.+?);/gi; //
  content = content.replace(rex, ''); //
  return content;
};

export const isImgLoaded = (nextMessage) => {
  const { attachments } = nextMessage.message;
  //если есть изображение и оно не подгрузилось
  if (
    Array.isArray(attachments) &&
    attachments.length > 0 &&
    attachments[0].type === 'image' &&
    !attachments[0].isLoaded
  )
    return false;
  else return true;
};

export const deletedDuplicateByAuthor = (arr, nextMessageIndexRef) => {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr.filter((el, i) => {
      if (
        !arr
          .slice(i + 1)
          .some(
            (elm) =>
              elm.message.author === el.message.author &&
              elm.message.senderNumber === el.message.senderNumber &&
              elm.message.channel === el.message.channel
          )
      ) {
        return true;
      } else {
        if (nextMessageIndexRef.current > 0) {
          nextMessageIndexRef.current--;
        }
        return false;
      }
    });
  }
  return [];
};

export const hideName = (author) => {
  if (!author) {
    return '*****';
  }
  let name = author.replaceAll(/\u2069|\u2068/g, '');
  // let newName = '';
  // for (let i = 0; i < name.length; i++) {
  //   const char = name[i];
  //   // проверка на эмодзи вначале и в конце строки
  //   if (
  //     (/([\uD800-\uDBFF])/g.test(char) && i === 0) ||
  //     (/([\uDC00-\uDFFF])/g.test(char) && i === 1) ||
  //     name.length - i > 3
  //   ) {
  //     newName += char;
  //   } else {
  //     newName += '*';
  //   }
  // }

  return name;
};

export const hideIdTelegram = (id) => {
  if (!id) {
    return '*****';
  }
  let idTg = id.replaceAll(/\u2069|\u2068/g, '');
  let newId = '';
  for (let i = 0; i < idTg.length; i++) {
    const char = idTg[i];
    if (idTg.length - i > 2) {
      newId += char;
    } else {
      newId += '*';
    }
  }

  return newId;
};

export const formatPhoneNumber = (phone = '', delimiter = ' ') => {
  let res = '';

  if (!phone) {
    return res;
  }
  let phoneNumber = phone.startsWith('+') ? phone : `+${phone}`;
  for (let i = 0; i < phoneNumber.length; i++) {
    const char = phoneNumber[i];

    if (phoneNumber.includes('+7') || phoneNumber.includes('+8')) {
      if ([0, 2, 3, 5, 6, 8, 10, 11].includes(i)) {
        res += char;
      } else if ([1, 4].includes(i)) {
        res += `${char} `;
      } else if ([7, 9].includes(i)) {
        res += `${char}${delimiter}`;
      }
    }
    // код Молдовы
    else if (phoneNumber.includes('+373')) {
      if ([0, 1, 2, 4, 5, 6, 8, 9, 10, 11].includes(i)) {
        res += char;
      } else if ([3].includes(i)) {
        res += `${char} `;
      } else if ([7].includes(i)) {
        res += `${char}${delimiter}`;
      }
    } else {
      res += char;
    }
  }

  return res;
};
